import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CameraStatusBrief = _resolveComponent("CameraStatusBrief")!
  const _component_CameraStatusInfo = _resolveComponent("CameraStatusInfo")!

  return (_openBlock(), _createBlock(_component_CameraStatusInfo, { item: _ctx.camera }, {
    default: _withCtx(() => [
      _createVNode(_component_CameraStatusBrief, {
        color: _ctx.camera.health_status.code,
        status: _ctx.showStatusLabel ? _ctx.statusLabel : '',
        description: _ctx.camera.health_status.code_desc,
        type: _ctx.statusType
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["color", "status", "description", "type"])
    ]),
    _: 3
  }, 8, ["item"]))
}